import { Avatar, styled } from '@mui/material';

export const StyledUserDataAvatar = styled(Avatar)(() => ({
	width: '100%',
	height: '100%',
	backgroundColor: '#3636B2',
}));

export const StyledProfileAvatarWrap = styled('div')(() => ({
	position: 'absolute',
	overflow: 'hidden',
	borderRadius: '50%',

	'& input': {
		display: 'none',
	},

	'& label': {
		display: 'flex',
	},

	'& *': {
		width: '100%',
		height: '100%',
	},

	'&:hover .backdrop': {
		opacity: 1,
	},

	width: '100px',
	height: '100px',
	marginTop: '-48px',
	left: '36px',
}));

export const StyledProfileAvatarOpacityBlock = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isDragOver',
})<{ isDragOver?: boolean }>(({ isDragOver }) => ({
	position: 'absolute',
	inset: 0,
	background: 'rgba(0,0,0,0.7)',
	opacity: isDragOver ? 1 : 0,
	transition: 'opacity .3s cubic-bezier(0.4, 0, 0.2, 1)',

	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	textWrap: 'balance',
	color: '#fff',

	cursor: 'pointer',
}));
